import React, {
    createContext,
    useCallback,
    useContext,
    useMemo,
    useState,
} from 'react';

/** Who the jobs portal UI is scoped for (drives sidebar filtering). */
const JobsPortalRoleContext = createContext({
    role: 'guest',
    setJobsPortalRole: () => {},
});

export function JobsPortalRoleProvider({ children }) {
    const [role, setRole] = useState('guest');
    const setJobsPortalRole = useCallback((next) => {
        if (next === 'company' || next === 'employee') {
            setRole(next);
        } else {
            setRole('guest');
        }
    }, []);

    const value = useMemo(
        () => ({ role, setJobsPortalRole }),
        [role, setJobsPortalRole],
    );

    return (
        <JobsPortalRoleContext.Provider value={value}>
            {children}
        </JobsPortalRoleContext.Provider>
    );
}

export function useJobsPortalRole() {
    return useContext(JobsPortalRoleContext);
}
